import { ValueObject } from "@singularsystems/neo-core";

export default class ParticipantAwardLookupCriteriaBase extends ValueObject {

    public participantId: string | null = null;

    // Client only properties / methods
}